//@file until/reportUtils.js

/**
 * 统计一个动作结果数组（result）中的动作数量。

 * @param {Array} r - 动作数组
 * @returns {number} 动作数量，如果不存在则返回 0
 */
export const countActions = (r) => {
    return (r !== undefined && r !== null) ? r.length : 0;
};

/**
 * 根据动作结果（Big/Small/No Thumb）计算准确率指标数组。
 * @param {object} result - 包含 'big-thumb', 'small-thumb', 'no-thumb' 动作分组的对象
 * @returns {Array<object>} 准确率指标数组
 */
export function calculateAccuracy(result) {
    const bigThumb = countActions(result['big-thumb']);
    const smallThumb = countActions(result['small-thumb']);
    const noThumb = countActions(result['no-thumb']);
    const totalAttempts = bigThumb + smallThumb + noThumb;

    if (noThumb > 0) {
        // 报告详细指标
        return [{
            title: '总正确率', ratio: totalAttempts > 0 ? ((bigThumb + smallThumb) / totalAttempts) * 100 : 0,
        }, {
            title: '自主发音正确率', ratio: totalAttempts > 0 ? (bigThumb / totalAttempts) * 100 : 0,
        }, {
            title: '提示后发音正确率', ratio: totalAttempts > 0 ? (smallThumb / totalAttempts) * 100 : 0,
        },];
    } else {
        // 报告简化指标
        const successfulAttempts = bigThumb + smallThumb;
        const ratio = successfulAttempts > 0 ? (bigThumb / successfulAttempts) * 100 : 0;
        return [{
            title: '正确率', ratio: isNaN(ratio) ? 0 : ratio,
        },];
    }
}

/**
 * 按指定键对 flows 数组进行分组和动作聚合。
 * @param {Array} flows - 原始学习流程数组
 * @param {string} groupKey - 分组的键 ('letter' 或 'initial')
 * @returns {Array} 聚合后的数据数组
 */
export function aggregateFlows(flows, groupKey) {
    if (!flows || flows.length === 0) return [];

    // 1. 按 groupKey 分组
    const groupedObj = flows.groupBy(f => f[groupKey]);
    const keys = Object.keys(groupedObj);

    // 2. 遍历分组，聚合 Actions 并计算准确率
    return keys.map(key => {
        const groupFlows = groupedObj[key];

        // 聚合组内所有流程的 actions
        let allActions = [];
        groupFlows.forEach(f => {
            allActions = [...allActions, ...f.actions];
        });

        const result = allActions.groupBy(a => a.action_name);
        const accuracys = calculateAccuracy(result);

        return {
            [groupKey]: key, // 声母或韵母键
            accuracys: accuracys,
        };
    });
}